export default [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "dojo_go",
  "mojo_go",
  "referral",
];
